export type SnMenuItemDisableExpression<D> = (data?: D | undefined) => boolean;
